import CenteredHeader from "./../../Molecules/CenteredHeader/CenteredHeader";
import IndustryImageTextSection from "./../../Molecules/IndustryImageTextSection/IndustryImageTextSection";
import G_EVOLUTION_IMG from "../../../assets/img/G_EVOLUTION_IMG.jpg";
// import NEGOCIOS_BENEFICION_IMG from "../../../assets/img/NEGOCIOS_BENEFICION_IMG.png";
import GPS_PORTATIL from "../../../assets/img/GPS_PORTATIL.png";
import IndustryBannerBgSection from "./../../Atoms/IndustryBannerBgSection/IndustryBannerBgSection";
// import FLOTA_MARINA_BANNER_RIGHT_IMAGE from "../../../assets/img/FLOTA_MARINA_BANNER_RIGHT_IMAGE.png";
import INVENTARIO_LOT  from "../../../assets/img/INVENTARIO_LOT.png";
import ALMACEN_DATOS from "../../../assets/img/ALMACEN_DATOS.png";
import SERVICIOS_NEGOCIOS from "../../../assets/img/SERVICIOS_NEGOCIOS.png";
import content from "./content"
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import { useScrollCtx } from "../../../store/providers/ScrollContext";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";

const AlliesNegocios = () => {
	const {language} = useLanguageCtx();
	const { dropdownHeader } = useScrollCtx();

  return (
		<>
			<ChangeableHeaderV2
				withTitle
				appearSecondNavbar={dropdownHeader} 
				titleBanner={content[language].header_title}
				spanTitleYellow={content[language].header_span_title}
			/>

			<div className="top-space-section">
				<CenteredHeader
					yellowText={content[language].negocios_yellow_title}
					boldText={content[language].negocios_bold_title}
				/>
			</div>

			<div className="top-space-section bottom-space-section">
				<IndustryImageTextSection
					image={{ img: G_EVOLUTION_IMG, alt: "G-Evolution App" }}
					boldText={content[language].negocios_bold_text}
					paragraphs={content[language].negocios_text}
				/>
			</div>

			<div className="light-blue-bg top-space-section bottom-space-section padding">
				<CenteredHeader
					yellowText={content[language].beneficios_yellow_title}
					boldText={content[language].beneficios_bold_title}
				/>
				<div className="top-space-section padding">
					<IndustryImageTextSection
						image={{ img: GPS_PORTATIL, alt: "Barco" }}
						imgRadius
						boldText={content[language].beneficios_bold_text}
						paragraphs={content[language].beneficios_paragraph_1}
						checkText={content[language].beneficios_list}
						paragraphs_2={content[language].beneficios_paragraph_2}
					/>
				</div>
			</div>

			<IndustryBannerBgSection route="telematica">
				<IndustryImageTextSection
					inBanner
					switchOrder
					image={{ img: INVENTARIO_LOT, alt: "INVENTARIO_LOT" }}
					yellowText={content[language].beneficiosIot_yellow_title}
					boldText={content[language].beneficiosIot_bold_title}
				>
					<p className="body-18 c-white">
						<span className="body-18 c-white bold">
							{content[language].beneficiosIot_span_1}
						</span>
						{content[language].beneficiosIot_text_1}
					</p>
					<p className="body-18 c-white">
						<span className="body-18 c-white bold">
							{content[language].beneficiosIot_span_2}
						</span>
						{content[language].beneficiosIot_text_2}
					</p>
				</IndustryImageTextSection>
			</IndustryBannerBgSection>

			<div className="light-blue-bg top-space-section bottom-space-section padding">
				<IndustryImageTextSection
					switchOrder
					image={{
						img: ALMACEN_DATOS,
						alt: "ALMACEN_DATOS",
					}}
					imgRadius
					responsiveImgPosition="first"
				>
					<p className="body-18 c-black">
						<span className="body-18 bold c-black">
							{content[language].beneficiosIot_span_3}
						</span>
						{content[language].beneficiosIot_text_3}
					</p>
					<p className="body-18 c-black">
						<span className="body-18 bold c-black">
							{content[language].beneficiosIot_span_4}
						</span>
						{content[language].beneficiosIot_text_4}
					</p>
				</IndustryImageTextSection>
			</div>

			<div className="top-space-section bottom-space-section">
				<IndustryImageTextSection
					image={{
						img: SERVICIOS_NEGOCIOS,
						alt: "SERVICIOS_NEGOCIOS",
					}}
					imgRadius
				>
					<p>
						<span className="body-18 bold c-black">
							{content[language].beneficiosIot_span_5}
						</span>
						{content[language].beneficiosIot_text_5}
					</p>
					<p className="body-18 bold c-black bold">
						{content[language].beneficiosIot_bold_text}
					</p>
				</IndustryImageTextSection>
			</div>
		</>
	);
};

export default AlliesNegocios;
